import { IAnswer, IQuestion } from '@/store/ducks/products/types';

export type optionType = 'radio' | 'checkbox' | 'additionals';

export const getAnswerType = (option: IQuestion): optionType => {
  const { minimum_of_answers, maximum_of_answers, select_options } = option;

  const isRadio = minimum_of_answers === 1 && maximum_of_answers === 1;
  const isAdditionals = select_options.find((answer) => answer.maximum_quantity > 1);

  if (isRadio) return 'radio';
  if (isAdditionals) return 'additionals';
  return 'checkbox';
};

export const insertSelectOption = (answer: IAnswer, option: IQuestion) => {
  const type = getAnswerType(option);
  const { id, title, value, chosen, quantity, question_id } = answer;

  const getQuantity = () => {
    if (quantity) return quantity.toString();

    return type === 'additionals' ? '0' : '1';
  };

  return {
    id,
    title,
    value,
    chosen: chosen ?? false,
    questionId: question_id,
    quantity: getQuantity(),
  };
};

export interface IOptionsRef {
  resetOptionsStep: () => void;
}
